export default `import (
  "github.com/golang-jwt/jwt"
)

const PrivateKey = "YOUR_PRIVATE_SSO_KEY"

func createCannyToken(user map[string]interface{}) (string, error) {
  token := jwt.NewWithClaims(jwt.SigningMethodHS256, jwt.MapClaims{
    "avatarURL": user["avatarURL"], // optional, but preferred
    "email": user["email"],
    "id": user["id"],
    "name": user["name"],
  })
  return token.SignedString([]byte(PrivateKey));
}
`;
